<template>
  <li v-if="isAuthorized">
    <slot name="before"/>
    <b-dropdown variant="link" right toggle-class="user-menu-toggle">
      <template v-slot:button-content>
        <span class="user-name">{{ userName }}</span>
        <span class="caret"></span>
      </template>
      <template v-for="(link, index) in links">
        <template v-if="link.visible">
          <b-dropdown-item v-if="link.to" :key="index" :to="link.to">
            {{ link.label }}
          </b-dropdown-item>
          <b-dropdown-item v-else-if="link.onClick" :key="index" @click="link.onClick">
            {{ link.label }}
          </b-dropdown-item>
          <b-dropdown-item v-else :key="index" :href="link.url" :target="link.target">
            {{ link.label }}
          </b-dropdown-item>
        </template>
      </template>
      <b-dropdown-divider></b-dropdown-divider>
      <b-dropdown-item @click="logout">Выход</b-dropdown-item>
    </b-dropdown>
    <slot name="after"/>
  </li>
</template>

<script>
import { ApiClient } from '../helpers/api-client/ApiClient'
import { ResponseStatuses } from '../../enums/ResponseStatuses'
import mainMixin from '../mixins/mainMixin'

export default {
  name: 'UserMenuItem',
  mixins: [mainMixin],

  data: () => ({
    dropdownOpen: false
  }),

  props: {
    links: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    userName () {
      if (this.user) {
        return this.user.name ? this.user.name : this.user.email
      }

      return null
    }
  },

  methods: {
    clickDropdown () {
      this.dropdownOpen = !this.dropdownOpen
    },

    logout () {
      ApiClient.logout()
        .then(response => {
          if (response.data.status === ResponseStatuses.Success) {
            this.$store.dispatch('flushAuthorize')
            this.$router.push('/login')
          }
        })
    }
  }
}
</script>
